import { Outlet, useRoutes, Navigate } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import AbelScanLayout from '../layout';
import layoutConfig from '../config/layoutConfig';
import { UnexpectedErrorCard, PageNotFoundCard } from '../components/ErrorCard';

import Dashboard from './Dashboard';
import Search from './Search';

import BlockView from "./BlockView";
import TxView from "./TxView";
import AddressView from './AddressView';

import ViewBlock from './ViewBlock';
import ViewTx from './ViewTx';
import ViewAddress from './ViewAddress';
import ViewMempoolTx from "./ViewMempoolTx";

const routes_mapping = [
  {
    path: '/',
    element: (
      <AbelScanLayout config={layoutConfig}>
        <Outlet />
      </AbelScanLayout>
    ),
    children: [
      { index: true, element: <Navigate to={'home'} replace /> },
      { path: 'home', element: <Dashboard /> },
      { path: 'search', element: <Search /> },
      { path: 'blocks', element: <BlockView /> },
      { path: 'block/:block_height_or_hash', element: <ViewBlock /> },
      { path: 'txs', element: <TxView /> },
      { path: 'tx/:txid', element: <ViewTx /> },
      { path: 'mempool/:txid', element: <ViewMempoolTx /> },
      { path: 'addresses', element: <AddressView /> },
      { path: 'address/:address', element: <ViewAddress /> },
      { path: '*', element: <PageNotFoundCard /> },
    ],
  },
];

const App = () => {
  return <ErrorBoundary FallbackComponent={UnexpectedErrorCard}>{useRoutes(routes_mapping)}</ErrorBoundary>;
};

export default App;